import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import isClient from 'commons/isClient';
import CtaLink from 'components/essentials/Cta/CtaLink';
import ImageSliderStandard from 'components/consumer/image-slider-standard';
import InstagramImages from './components/InstagramImages';

class ImageSlider extends Component {
  componentDidMount() {}

  render() {
    if (this.props.config.instagram) {
      return (
        <InstagramImages
          render={renderProps => <ImageSlider {...renderProps} />}
        />
      );
    }

    const { hideArrowsIfAllSlidesVisible = false } = this.props;

    const {
      images,
      title,
      titlePart2,
      subTitle,
      subsubTitle,
      containerBackgroundColor,
      navType,
    } = this.props.config;

    const isHomepage = isClient()
      ? window.location.pathname.split('/').pop() === ''
      : false;

    return (
      <div
        className={classNames(
          'px-0 py-10 [background:#f7f7f7] mx-0 my-8 min-[1200px]:px-0 min-[1200px]:py-[4.5rem] max-[767px]:overflow-[inherit] m-0',
          { [this.props.className]: this.props?.className }
        )}
        style={{ background: containerBackgroundColor }}
      >
        {title && (
          <h1
            className="font-sans text-[28px] font-bold text-center mt-0 mx-auto mb-1.5 !text-gray text-4xl leading-[2.37rem] tracking-[-0.062rem] max-[1400px]:text-[2rem] max-[1400px]:leading-[2.25rem] max-[1400px]:tracking-[-0.062rem] max-[800px]:text-[1.75rem] max-[800px]:leading-[1.85rem] max-[800px]:tracking-[-0.05rem]"
            style={title.style}
          >
            {title.name.split('\n').map(it => (
              <div key={it}>{it}</div>
            ))}
            {titlePart2 && <span className="!text-gray">{titlePart2}</span>}
          </h1>
        )}
        {subTitle && (
          <div className="mx-auto my-0 font-sans text-[28px] font-bold tracking-[-.75px] leading-[1.2] text-center mb-[50px]">
            {subTitle.name.split('\n').map(it => (
              <div key={it}>
                {subTitle.link ? (
                  <CtaLink
                    to={subTitle.link}
                    styling="solid-button"
                    color="brand"
                  >
                    {it}
                  </CtaLink>
                ) : (
                  <div style={subTitle.style}>{it}</div>
                )}
              </div>
            ))}
            {subsubTitle && (
              <div className="mx-auto my-0 font-sans text-[28px] font-bold tracking-[-.75px] leading-[1.2] text-center mt-2.5">
                {subsubTitle.name.split('\n').map(it => (
                  <div key={it}>
                    {subsubTitle.link ? (
                      <CtaLink to={subsubTitle.link}>{it}</CtaLink>
                    ) : (
                      <div style={subsubTitle.style}>{it}</div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        <ImageSliderStandard
          config={{
            imgArray: images,
            sliderConfig: {
              visibleSlides: 0,
              navType: navType || 'Button',
              imageWidth: isHomepage ? 440 : 630,
              imageHeight: 350,
              infinite: isHomepage,
            },
            variation: { value: 'Manual' },
          }}
          hideArrowsIfAllSlidesVisible={hideArrowsIfAllSlidesVisible}
        />
      </div>
    );
  }
}

ImageSlider.propTypes = {
  config: PropTypes.shape({
    containerBackgroundColor: PropTypes.string,
    images: PropTypes.array,
    instagram: PropTypes.bool,
    navType: PropTypes.string,
    subsubTitle: PropTypes.shape({
      link: PropTypes.string,
      name: PropTypes.string,
      style: PropTypes.object,
    }),
    subTitle: PropTypes.shape({
      link: PropTypes.string,
      name: PropTypes.string,
      style: PropTypes.object,
    }),
    title: PropTypes.shape({
      name: PropTypes.string,
      style: PropTypes.object,
    }),
    titlePart2: PropTypes.string,
  }),
  hideArrowsIfAllSlidesVisible: PropTypes.bool,
  className: PropTypes.string,
};

export default ImageSlider;
